<template>
  <div>
    <v-container>
      <v-btn @click="addGroup" fab fixed bottom right dark color="indigo">
        <v-icon dark>add</v-icon>
      </v-btn>
      <v-row>
        <v-col cols="12" md="8">
          <v-form v-model="valid" @submit.prevent="submit" ref="form">
            <v-text-field
              v-model="name"
              :rules="nameRules"
              :counter="250"
              label="Nome da segmentação"
              placeholder="Máximo de 250 caracteres"
              required
            ></v-text-field>
            <v-row align="center" v-if="groups.length > 1">
              <v-col
                cols="12"
                md="5"
              >
                O Lead precisa atender as condições de    
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-select 
                  v-model="group_connective"
                  :rules="required"
                  :items="[
                  {
                    value: 'and', text: 'Todos os '
                  },
                  {
                    value: 'or', text: 'Qualquer um dos '
                  },
                ]"></v-select>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                grupos
              </v-col>
            </v-row>
            <v-card v-for="(g, i) in groups" :key="i">
              <v-card-title>        
                Grupo {{i + 1}} de condições para segmentar os leads 

                <v-btn v-if="groups.length > 1" @click="removeGroup(i)" title="Remover segmento" fab dark small color="error">
                        <v-icon dark>remove</v-icon>
                      </v-btn>  
              </v-card-title>
              <v-card-text>        
                <v-container>
                  <v-row align="center">
                    <v-col
                      cols="12"
                      md="3"
                    >
                      O Lead precisa atender     
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-select 
                        v-model="g.connective"
                        :rules="required"
                        :items="[
                        {
                          value: 'and', text: 'Todas as '
                        },
                        {
                          value: 'or', text: 'qualquer uma das '
                        },
                      ]"></v-select>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      condições abaixo:
                    </v-col>
                  </v-row>     
                  <v-row v-for="(c, index) in g.conditions" :key="index">
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-select 
                        v-model="c.type"
                        :rules="required"
                        :items="[
                        {
                          value: 'lead_prop',
                          text: 'Dados do lead'
                        }
                      ]">
                      </v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        md="2"
                      >
                      <v-select 
                        v-model="c.field"
                        :rules="required"
                        :items="[
                          {
                            value: 'tags',
                            text: 'Tag'
                          }
                      ]">
                      </v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        md="2"
                      >
                       <v-select 
                        v-model="c.condition"
                        :rules="required"
                        :items="[
                          {
                            value: 'has',
                            text: 'Contém'
                          },
                          {
                            value: 'hasn',
                            text: 'Não contém'
                          },
                      ]">
                      </v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        md="3"
                      >
                      <v-select 
                        v-model="c.value"
                        :rules="required"
                        :items="$store.state.tags.map(t => {return {value: t.id, text: t.tag}})">
                      </v-select>
                      <!-- <v-autocomplete
                        v-model="c.value"
                        :items="tags"                        
                        :loading="isLoading"
                        :search-input.sync="search"
                        color="white"
                        hide-no-data
                        hide-selected
                        item-text="tag"
                        item-value="id"
                        label="Tags"
                        placeholder="Comece a digitar para procurar"
                        prepend-icon="mdi-tag"
                      >
                      </v-autocomplete>-->
                    </v-col>
                    <v-col
                        cols="12"
                        md="2"
                      >
                      <v-btn @click="removeCondition(g,index)" title="Remover segmento" fab dark small color="error">
                        <v-icon dark>remove</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-btn @click="addCondition(g)">Adicionar condição</v-btn>
                </v-container>
              </v-card-text>
              <v-card-text>
                <v-btn 
                  color="primary"
                  type="submit"            
                  :disabled="!valid"
                >
                    Salvar segmentação
                </v-btn>
              </v-card-text>
            </v-card>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {

  name: 'index',
  watch: {
    search (val) {      
      // Items have already been loaded
      if (this.tags.length > 0) return

      // Items have already been requested
      if (this.isLoading) return

      this.isLoading = true      
      // Lazily load input items
      fetch(`${process.env.VUE_APP_API_BASE_URL}/api/tags`, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access_token')
        }
      })
        .then(res => res.json())
        .then(res => {
          this.entries = res;
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    },
  },
  props: {
    selected: {
      type: Object,
      default () {return {}}
    }
  },
  methods: {
    addCondition(g) {
      if (g.conditions.length < 5) {
        g.conditions = [...g.conditions, {
          type: 'lead_prop',
          field: 'tags',
          condition: 'has',
          value: ''
        }];      
      }
    },
    removeGroup(index) {
      if (this.groups.length > 1) {
        this.groups.splice(index, 1);
      }
    },
    addGroup() {
      this.groups.push({
        connective: 'and',
        conditions: [
        {
          type: 'lead_prop',
          field: 'tags',
          condition: 'has',
          value: ''
        }
        ]
      });
    },
    removeCondition(g, index) {
      if (g.conditions.length > 1) {
        g.conditions.splice(index, 1);
      }
    },
    submit(e) {
      e.preventDefault();      
      if (this.$refs.form.validate()) {
        const data = {
          data: {
            name: this.name,
            group_connective: this.group_connective,
            groups: this.groups,
          }
        }
        if (this.selected) {
          data.data.id = this.selected.id
        }
        this.$store.dispatch('createLeadSegmentation', data);
      }
    }
  },
  data () {
    return {
      tagLimit: 60,
      required: [
        v => !!v || 'Campo obrigatório',
      ],
      nameRules: [
        v => !!v || 'Insira o nome da segmentação',
        v => v && v.length <= 250 || 'O nome da segmentação deve ter no máximo 250 caracteres',
      ],
      parsedSelected: this.selected ? JSON.parse(this.selected.json) : null,
      group_key: 0,
      conditions_key: 0,
      valid: false,
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      name: '',
      group_connective: 'and',
      groups: [
        {
          connective: 'and',
          conditions: [
          ]
        }
      ]
    }
  },
  mounted() {
    if (this.selected) {
      this.name = this.selected.name
      this.group_connective = this.parsedSelected.group_connective
      this.groups = this.parsedSelected.groups
    } else {
      this.groups[0].conditions.push({
        type: 'lead_prop',
        field: 'tags',
        condition: 'has',
        value: ''
      })
    }
  },
  created() {
    this.$store.dispatch('fetchTags');
  },
  computed: {
    tags () {      
      return this.entries.map(entry => {        
        const {id, tag} = entry
        return {
          id,
          tag
        }
      })
    },
  },
}
</script>

<style lang="css" scoped>
</style>